import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  authenticationTab,
  forgotPassword,
} from '../../store/actions/Authentication';
import { PasswordForgot } from '../../components/';
import { addFlashMessage, clearMessage } from '../../store/actions/Flash';
import Logo from '../../components/Header/Logo.svg';
import crowdfunderImage from '../../containers/ResetPassword/crowdfunder.png';
import circlefixImage from '../../containers/ResetPassword/circlefix.png';
import nikeImage from '../../containers/ResetPassword/nike.png';
import yahooImage from '../../containers/ResetPassword/yahoo.png';
import briogeoImage from '../../containers/ResetPassword/briogeo.png';
import wavemakerImage from '../../containers/ResetPassword/wavemaker.png';
import instyleImage from '../../containers/ResetPassword/instyle.png';
import ssImage from '../../containers/ResetPassword/76.png';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentEmail: '',
    };
    this.handlerInputChange = this.handlerInputChange.bind(this);
    this.handleUpdateActiveTab = this.handleUpdateActiveTab.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
  }

  handlerInputChange(event) {
    const { name, type, checked, value } = event.target;
    const newValue = type === 'checkbox' ? checked : value;

    this.setState({ [name]: newValue });
  }

  handleForgotPassword(event) {
    event.preventDefault();
    const email = { email: this.state.currentEmail };

    if (this.state.currentEmail) {
      this.props.dispatchForgotPassword(email);
    } else {
      this.props.dispatchErrorMessage(['Please enter an email']);
    }
  }

  handleUpdateActiveTab(event) {
    event.preventDefault();
    const activeTab = event.target.id === 'client';
    this.props.setActiveAuthenticationTab(activeTab);
  }

  render() {
    const { currentEmail } = this.state;

    const { clientTabActive } = this.props;

    return (
      <div className="page login-page">
        <div className="logo">
          <a href="https://dreamitreel.com" className="navbar-brand">
            <img alt="Dream it Reel Logo" src={Logo} />
          </a>
        </div>
        <div className="reset-password">
          <div className="reset-password__form-container">
            <PasswordForgot
              handleInputChange={this.handlerInputChange}
              currentEmail={currentEmail}
              handleUpdateActiveTab={this.handleUpdateActiveTab}
              clientTabActive={clientTabActive}
              handleForgotPassword={this.handleForgotPassword}
            />
          </div>
        </div>
        <div className="image-container">
          <div className="content-container">
            <div className="image-container__advanced-info">
              <div className="advanced-text-info">
                <h1 className="text font-weight-bold t-40">Video creation made simple</h1>
                <ul>
                  <li>A simple, streamlined process to get things started</li>
                  <li>Creative talent spanning from concept to creation</li>
                  <li>Next level project feedback and collaboration</li>
                </ul>
              </div>
              <div className="advanced-images">
                <div className="image-column">
                  <div className="image-block">
                    <img src={yahooImage} />
                  </div>
                  <div className="image-block">
                    <img src={briogeoImage} />
                  </div>
                </div>
                <div className="image-column">
                  <div className="image-block">
                    <img src={crowdfunderImage} />
                  </div>
                  <div className="image-block">
                    <img src={circlefixImage} />
                  </div>
                </div>
                <div className="image-column">
                  <div className="image-block">
                    <img src={nikeImage} />
                  </div>
                  <div className="image-block">
                    <img src={ssImage} />
                  </div>
                </div>
                <div className="image-column">
                  <div className="image-block">
                    <img src={instyleImage} />
                  </div>
                  <div className="image-block">
                    <img src={wavemakerImage} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

ForgotPassword.propTypes = {
  dispatchForgotPassword: PropTypes.func,
  dispatchErrorMessage: PropTypes.func,
  setActiveAuthenticationTab: PropTypes.func,
  clientTabActive: PropTypes.bool,
};

const mapStateToProps = state => ({
  clientTabActive: state.authentication.clientActiveTab,
});

const mapDispatchToProps = dispatch => ({
  setActiveAuthenticationTab: clientTabActive => {
    dispatch(authenticationTab(clientTabActive));
  },
  dispatchForgotPassword: email => {
    dispatch(forgotPassword(email));
  },
  dispatchErrorMessage: message => {
    dispatch(clearMessage());
    dispatch(addFlashMessage(message, 'error'));
  },
  dispatchSuccessMessage: message => {
    dispatch(clearMessage());
    dispatch(addFlashMessage(message, 'success'));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword/ForgotPassword.js